import axios from '../utils/axios';

export default function disconnectSocials (adminId, data) {
    return axios.post(`/admin/${adminId}/disconnect-socials`, data);
}